import React from 'react'
import { BsArrowLeft } from "react-icons/bs"
import useAppContext from '../../hook/useAppContext'
import FriendsList from './FriendsList'
import './friends.css'

const Friends = () => {

      const {user, showFriend, setShowFriend} = useAppContext()
      const {friends} = user 

      const closeFriend = () => {
            setShowFriend(!showFriend)
      }

      return (
            <div className={showFriend ? "friends_wrapper active" : "friends_wrapper"}>
                  <div className="friends_header flex">
                        <button className="btn_friends__close flex" onClick={() => closeFriend()}>
                              <BsArrowLeft />
                        </button>
                        <h2>Friends</h2>
                  </div>
                  <div className="friends_content">
                        <FriendsList friends={friends} />
                  </div>
            </div>
      )
}

export default Friends
